export default __webpack_public_path__ + "static/media/iconfinder_187_Js_logo_logos_4373213.90384b2d.svg";